document.querySelectorAll('.local-navigation').forEach((list) => {
  const items = list.querySelectorAll('li');

  items.forEach((item) => {

    // hover
    item.addEventListener('mouseenter', () => {
      items.forEach((li) => {
        li.classList.remove('active');
      });
    });

   ["click", "mouseleave"].forEach((eventType) => {
      item.addEventListener(eventType, () => {
        items.forEach((li) => {
          li.classList.remove('active');
          li.querySelector('a').blur();
        });
        items[0].classList.add('active');
      });
    });

  });
});

document.querySelectorAll('a[href^="#"]').forEach((link) => {
  link.addEventListener('click', (event) => {
    const target = document.querySelector(link.getAttribute('href'));

    if (!target) return;

    event.preventDefault();

    const header = document.querySelector('header');
    const headerHeight = header?.offsetHeight || 0;
    const targetPosition =
      target.getBoundingClientRect().top +
      window.scrollY -
      headerHeight;

    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth'
    });
  });
});

const normalizeJudgeMeReviewText = (scope = document) => {
  scope.querySelectorAll('.jdgm-prev-badge__text').forEach((element) => {
    const rawText = (element.textContent || '').trim();
    if (!/\breviews?\b/i.test(rawText)) return;

    const numberMatch = rawText.match(/[\d,.]+/);
    if (!numberMatch) return;

    element.textContent = `(${numberMatch[0]})`;
  });
};

const initJudgeMeReviewTextNormalizer = () => {
  normalizeJudgeMeReviewText();

  if (!document.body) return;

  let pending = false;
  const queueNormalize = () => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => {
      normalizeJudgeMeReviewText();
      pending = false;
    });
  };

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches('.jdgm-prev-badge__text') || node.querySelector('.jdgm-prev-badge__text')) {
          queueNormalize();
          return;
        }
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Judge.me can rewrite badge text after initial render.
  setTimeout(queueNormalize, 300);
  setTimeout(queueNormalize, 1000);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initJudgeMeReviewTextNormalizer, { once: true });
} else {
  initJudgeMeReviewTextNormalizer();
}

const initGloboCloseCanvasFallback = () => {
  const closeCanvasByClass = () => {
    const canvasRoots = document.querySelectorAll('.theme-store-id-3247.gf-theme-version-1.spf-filter-tree-theme.offcanvas-open, .spf-filter-tree-theme.offcanvas-open');
    canvasRoots.forEach((element) => {
      element.classList.remove('offcanvas-open');
    });

    document.documentElement.classList.remove('offcanvas-open');
    document.body.classList.remove('offcanvas-open');

    if (window.location.hash === '#') {
      const cleanUrl = `${window.location.pathname}${window.location.search}`;
      window.history.replaceState(null, '', cleanUrl);
    }
  };

  const onCloseInteraction = (event) => {
    const closeButton = event.target.closest('.gf-close-canvas');
    if (!closeButton) return;

    requestAnimationFrame(() => {
      closeCanvasByClass();
    });

    setTimeout(() => {
      closeCanvasByClass();
    }, 200);
  };

  document.addEventListener('click', onCloseInteraction);
  document.addEventListener('touchend', onCloseInteraction, { passive: true });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initGloboCloseCanvasFallback, { once: true });
} else {
  initGloboCloseCanvasFallback();
}

document.addEventListener('click', (event) => {
  const popup = event.target.closest('#glFilter-search-popup');
  if (!popup) return;
  if (event.target.closest('.gl-backdrop, .gl-fullscreen-layer')) return;

  const backdrop = popup.querySelector('.gl-backdrop');
  if (backdrop) backdrop.click();
});
